import { createRouter, createWebHistory } from "vue-router";
import { getToken } from "@/utils/cookie.js";
import threeDspace from "@/views/threeDspace/threeDspace";
import login from "@/views/login/loginIndex";
import register from "@/views/login/RegisterPage";
import forgetPassword from "@/views/login/forgetPassword";
import shopping from "@/views/ipStore/ipShopping";
import ipDetail from "@/views/ipStore/ipDetail";
import gameCenter from "@/views/game/gameCenter";
import gameDetail from "@/views/game/gameDetail";
import buyIndex from "@/views/buy/buyIndex";
import buyDetail from "@/views/buy/buyDetail";
import shoppingCar from "@/views/shopping/shoppingCar";
import sureOrder from "@/views/shopping/sureOrder";
import myCenter from "@/views/myCenter/myCenter";
import walletIndex from "@/views/wallet/walletIndex";
import walletDetail from "@/views/wallet/walletDetail";
import myOrder from "@/views/myOrder/myOrder";
import orderDetail from "@/views/myOrder/orderDetail";
import afterSale from "@/views/myOrder/afterSales";
import refundOnly from "@/views/myOrder/refundOnly";
import returnRefund from "@/views/myOrder/returnRefund";
import barter from "@/views/myOrder/barterIndex";
import viewSpace from "@/views/space/ViewSpace.vue";

// 定义路由
const routes = [
  {
    path: "/",
    name: "home",
    component: threeDspace,
    meta: {
      keepAlive: true,
    },
  },
  {
    path: "/login",
    name: "login",
    component: login,
  },
  {
    path: "/login/register",
    name: "register",
    component: register,
  },
  {
    path: "/login/forgetPassword",
    name: "forgetPassword",
    component: forgetPassword,
  },
  {
    path: "/shopping",
    name: "shopping",
    component: shopping,
    meta: {
      keepAlive: true,
    },
  },
  {
    path: "/shopping/detail/:id?",
    name: "ipDetail",
    component: ipDetail,
  },
  {
    path: "/_game",
    name: "game",
    component: gameCenter,
    meta: {
      keepAlive: true,
    },
  },
  {
    path: "/_game/detail/:id?",
    name: "gameDetail",
    component: gameDetail,
  },
  {
    path: "/buy",
    name: "buy",
    component: buyIndex,
    meta: {
      keepAlive: true,
    },
  },
  {
    path: "/buyDetail/:id?",
    name: "buyDetail",
    component: buyDetail,
  },
  {
    path: "/shoppingCar",
    name: "shoppingCar",
    component: shoppingCar,
    meta: { requiresAuth: true },
  },
  {
    path: "/sureOrder/:data?",
    name: "sureOrder",
    component: sureOrder,
    meta: { requiresAuth: true },
  },
  {
    path: "/myOrder",
    name: "myOrder",
    component: myOrder,
    meta: { requiresAuth: true },
  },
  {
    path: "/myOrder/detail/:id?",
    name: "orderDetail",
    component: orderDetail,
    meta: { requiresAuth: true },
  },
  {
    path: "/myOrder/afterSale",
    name: "afterSale",
    component: afterSale,
    meta: { requiresAuth: true },
  },
  {
    path: "/afterSale/refundOnly",
    name: "refundOnly",
    component: refundOnly,
    meta: { requiresAuth: true },
  },
  {
    path: "/afterSale/returnRefund",
    name: "returnRefund",
    component: returnRefund,
    meta: { requiresAuth: true },
  },
  {
    path: "/afterSale/barter",
    name: "barter",
    component: barter,
    meta: { requiresAuth: true },
  },
  {
    path: "/myCenter",
    name: "myCenter",
    component: myCenter,
    meta: { requiresAuth: true },
  },
  {
    path: "/wallet",
    name: "wallet",
    component: walletIndex,
    meta: { requiresAuth: true },
  },
  {
    path: "/wallet/detail",
    name: "walletDetail",
    component: walletDetail,
    meta: { requiresAuth: true },
  },
  {
    path: "/space/view/:slug?",
    name: "viewSpace",
    component: viewSpace,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, _from, next) => {
  if (to.meta.requiresAuth && !getToken()) {
    try {
      localStorage.setItem("wantToJump", to.fullPath);
    } catch {
      /* ignore */
    }
    next({ path: "/login" });
    return;
  }
  next();
});

export default router;
